import 'idempotent-babel-polyfill';
import alt from '../alt';
import ReceiptActions from './ReceiptActions';

class ReceiptStore {
    constructor() {
        this.state = {
            orderCode: '',
            Details: {},
            emailAddress: '',
            hasError: false,
            isFromOrder: false,
        };

        this.bindListeners({
            getOrderDetails: ReceiptActions.ORDER_DETAIL_SUCCESS,
            resetOrderDetails: ReceiptActions.RESET_ORDER_DETAIL,
            fieldChanged: ReceiptActions.CHANGE_FIELD,
            setFromOrderFlag: ReceiptActions.SET_FROM_ORDER_FLAG,
        });
    
    }

    setFromOrderFlag(flag) {
        this.setState({
            isFromOrder: flag
        });
    }

	fieldChanged(diff) {
		this.setState(diff);
	}

    resetOrderDetails() {
        this.setState({
            orderCode: '',
            emailAddress: '',
            Details: {}
        });
    }

    getOrderDetails(order) {
        if(order === null) {
            this.setState({
                hasError: true,
                Details: {}
            });
        } else {
            this.setState({
                hasError: false,
                Details: order,
            });
        }
    }
}

export default alt.createStore(ReceiptStore,"ReceiptStore");


// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/GuestCheckout/ReceiptStore.js